<template>
	<div id="app">
		<el-container>
			<el-header class="div-header">
				<Header />
				<el-divider class="header-divider"></el-divider>
			</el-header>

			<div class="main-div">
				<el-container class="main-div parentDiv">
					<splitpanes class="default-theme defaultStyle custom-splite">
						<pane size="100" class="SideBarLeft">
              <!--SID1003 Body Part -->
							<template>
								<el-container>
									<div class="SID1003__quill">
										<!-- Breadcrumb section -->
										<section>
											<el-breadcrumb separator-class="el-icon-arrow-right" class="mailDestlink">
												<el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
												<el-breadcrumb-item :to="{ path: '' }">管理者からのお知らせ：登録</el-breadcrumb-item>
											</el-breadcrumb>
										</section>
                                        <div class="loginNotice"> 
                                            <span >ユーザーにお知らせする内容を登録して下さい。</span>
										</div>
										<el-row>
											<el-col :span="24" class="columnMandatoryIcon">
												<span class="mandatoryMark">*</span>
											</el-col>
										</el-row>										
										<!-- quillEditor section -->
                                        <section class="divQuillEditSection">
											<span class="alertSpan">{{ Errortext }}</span>
											
                                            <div class="div-quill-editor defaultsize">
                                            <div class="quill-editor-example">
                                            <!-- quill-editor -->
											
                                            <quill-editor class="Quill__editor__area" ref="myTextEditor"
                                                            v-model="content"
															:options="editorOption"
															property="getTextboxResult1003"
                                                            >
                                            </quill-editor>
                                            <div class="quill-code">
                                                <code class="hljs" v-html="contentCode"></code>
                                            </div>
                                            </div>
                                        </div>
                                     </section>
									<div class="Buttonquill">
                                       <el-button type="primary" plain  @click="registerNotification">登録</el-button>
										<el-button type="danger" @click="deleteNotification" plain>削除</el-button> 
									</div>
									</div>
								</el-container>
							</template>
              <!--SID1003 Body Part End-->
						</pane>
						<pane class="SideBarRight">
							<SideBar class="SidePane" />
						</pane>
					</splitpanes>
				</el-container>
			</div>
			<el-container class="footer-div">
				<el-footer class="footer-element">
					<FooterComponent />
				</el-footer>
			</el-container>
		</el-container>
	</div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import hljs from 'highlight.js';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import json from '../../components/config.json';
import { mapGetters } from "vuex";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import Common from '../../common/CommonFunc.js';
export default {
	name: "app",
	components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
        Pane,
        quillEditor
	},
	data() {
		return {
			form: {},
			editCheckValue: '',
			contractId: '',
			editorOption: {
				placeholder:'',
          modules: {
			toolbar: [
              ['bold'],
              [{ 'color': [] }],
              [{ 'align': [] }],
              ['link'],
              []
			],
           }
		},
		Errortext: ''
        }
    },
    computed: {
		...mapGetters("situation1003", [ 
			"getTextboxResult1003",
			"getStatus",
			"getEditStatus"
		]),
		...mapGetters("situation0001", [     
			"getContractId"
		]),
    editor(){

        return this.$refs.myTextEditor.quill
    },
    contentCode(){

        return hljs.highlightAuto(this.content).value
		},
		content: {

			get(){
			return this.getTextboxResult1003;
			},
			set (newvalue) {
				this.$store.commit('situation1003/setTextboxArticles', newvalue)
			}
		}
    },
    methods: {
        deleteNotification()
		{
			this.$LogButtonEvent("1003","Delete");
			this.$LogMethodIN("1003","deleteNotification");
			this.Errortext='';
			var quillEditorValue = this.getTextboxResult1003.replace( /(<([^>]+)>)/ig, '');
			if(quillEditorValue == " " || quillEditorValue == null )
			{
              this.Errortext="削除するコンテンツはありません";
			}
			else
			{
				this.Errortext='';
				this.$confirm(json["1003_delete_confirm_message"], json["1003_title"], {
					showCancelButton: true,		
					confirmButtonText: 'はい',
					cancelButtonText: 'いいえ',
					customClass:'increase-width',
				}).then(() => {
					var deleteDetails = {
						contract_id: this.contractId
					}
					this.$store.dispatch('communication1003/deleteTextboxComment', deleteDetails).then(() => {
						var status = this.getStatus
						if(status == 0){
							
							this.$alert( json["1003_delete_toast_message"], json["1003_delete_toast_title"], {
								confirmButtonText: 'OK',
					
							}).then(()=>{
								this.content = '';
								this.$store.dispatch('communication/getUserNotice');
							})
							
						}else{
							this.$alert( json["1003_delete_failure_message"], json["1003_delete_failure_title"], {
								confirmButtonText: 'OK',
					
							});
						}  
					})
					.catch((error) => { 
						console.log(error);
						this.$alert( json["1003_delete_failure_message"], json["1003_delete_failure_title"], {
							confirmButtonText: 'OK',
				
						});
					});
				})
			}
			this.$LogMethodOut("1003","deleteNotification");
		},
		registerNotification() {
			this.$LogButtonEvent("1003","Register");
			this.$LogMethodIN("1003","registerNotification");
			var quillEditorValue = this.getTextboxResult1003.replace( /(<([^>]+)>)/ig, '');
			if(quillEditorValue == "" )
			{
				
              this.Errortext="お知らせ内容を入力してください。";
			}
			else
			{
				
				this.Errortext='';
				if(quillEditorValue.length <= 7500){

					this.Errortext='';
					
						var editTextbox ={
							text: Common.Session.linkify(this.$refs.myTextEditor.value)	
						};
						this.$store.dispatch('communication1003/editTextboxComment', editTextbox).then(() => {

							var editStatus = this.getEditStatus;

							if(this.editCheckValue == 1 )
							{
								if(editStatus == 0)
								{
									
									this.$store.dispatch('communication1003/getTextboxData1003');
									this.$alert(json["1003_update_success_message"], json["1003_update_success_title"], {
										confirmButtonText: 'OK',
									})
								}
								else
								{
									this.$alert(json["1003_update_failure_message"], json["1003_update_failure_title"], {
										confirmButtonText: 'OK',
									});
								}

							}
							else
							{

								if(editStatus == 0)
								{
									this.$alert(json["1003_register_success_message"], json["1003_register_success_title"], {
										confirmButtonText: 'OK',
									})
								}
								else
								{
									this.$alert(json["1003_register_failure_message"], json["1003_register_failure_title"], {
										confirmButtonText: 'OK',
									});
								}
							}
						})
						.catch((error) => { 
							console.log(error);
							this.$alert(json["1003_update_failure_message"], json["1003_update_failure_title"], {
								confirmButtonText: 'OK',
							});
						});
				}else{
					this.Errortext="通知内容は7500文字以内で入力してください。";
				}
				
			}
			this.$LogMethodOut("1003","registerNotification");
		}
	},
	mounted() {
		//get the contract_id value from session
     this.contractId = this.getContractId;
		// Load page tables
		//Get table articles during page load		
	this.$store.dispatch('communication1003/getTextboxData1003').then(()=>{
		if(this.getTextboxResult1003 != ""){
			this.editCheckValue = 1
		}else{
			this.editCheckValue = 0
		}
		
		});
 },
	beforeCreate(){
		//For the screen Title
     document.title = "お知らせ内容登録";
	},
    
    
     
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "1003.css";
</style>